<template>
  <div id="">
    <div class="">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="top-bar sticky" id="header_menu">
      <div class="d-flex justify-content-between topheader">
        <div class="align-self-center leftheader">
          <div class="btnsidebar">
            <!-- data-bs-toggle="modal" data-bs-target="#exampleModal" -->
          </div>
          <div class="lightning">
            <img width="432" height="212" src="/static/img/landing/download-1-2.png"
              class="image wp-image-2635  attachment-full size-full" alt="" decoding="async" loading="lazy"
              style="max-width: 100%; height: auto;" sizes="(max-width: 432px) 100vw, 432px">
          </div>
          <div class="brand-logo">
            <a href="/" class="custom-logo-link" rel="home" aria-current="page"><img width="960" height="960"
                src="/static/img/landing/cropped-GMZ555-2.png" class="custom-logo" alt="VENOM168" decoding="async"
                sizes="(max-width: 960px) 100vw, 960px"></a>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="align-self-center mx-1">
            <div class="online-icon">
              <div><img width="110" height="110" src="/static/img/landing/online.gif"
                  class="image wp-image-761  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;" sizes="(max-width: 110px) 100vw, 110px"></div>
            </div>
          </div>
          <div class="align-self-center text-center mx-1 rightmenubtn" id="htmlHeader">
            <div class="">
              <button class="btn btn-login-top">
                <div class="textwidget"><a class="wpGlobalA" data-toggle="modal" data-target="#modalLogin">เข้าสู่ระบบ</a>
                </div>
              </button><button class="btn btn-login-top">
                <div class="textwidget"><a class="wpGlobalA" data-toggle="modal"
                    data-target="#modalRegister">สมัครสมาชิก</a>
                </div>
              </button>
            </div>
          </div>



        </div>
      </div>
      <div class="secon-bar">
        <div class="center-header headertop">
          <div class="menu-menu-container">
            <ul id="menu-menu" class="menu">


            </ul>
          </div>
        </div>
      </div>

    </div>



    <div class="insidebarleft">
      <a href="#" class="custom-logo-link" rel="home" aria-current="page"><img width="960" height="960"
          src="/static/img/landing/cropped-GMZ555.png" class="custom-logo" alt="VENOM168" decoding="async"
          srcset="/static/img/landing/cropped-GMZ555.png 960w, /static/img/landing/cropped-VENOM168-300x300.png 300w, /static/img/landing/cropped-VENOM168-150x150.png 150w, /static/img/landing/cropped-VENOM168-768x768.png 768w, /static/img/landing/cropped-VENOM168-50x50.png 50w"
          sizes="(max-width: 960px) 100vw, 960px"></a>
      <div class="menu-menu-container">

      </div>
    </div>
    <div class="overlaysidebar"></div>









    <div class="containpage page">

      <div data-elementor-type="wp-page" data-elementor-id="216" class="elementor elementor-216">
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-8146cd9 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
          data-id="8146cd9" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-no">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2212b25"
              data-id="2212b25" data-element_type="column">


              <div class="elementor-widget-wrap elementor-element-populated e-swiper-container">
                <div
                  class="elementor-element elementor-element-4a3cf52 dottop elementor-arrows-position-inside elementor-widget elementor-widget-image-carousel e-widget-swiper"
                  data-id="4a3cf52" data-element_type="widget"
                  data-settings="{&quot;slides_to_show&quot;:&quot;2&quot;,&quot;navigation&quot;:&quot;arrows&quot;,&quot;image_spacing_custom&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:10,&quot;sizes&quot;:[]},&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;yes&quot;,&quot;speed&quot;:500}"
                  data-widget_type="image-carousel.default">
                  <div class="elementor-widget-container">

                    <swiper v-bind="swiperOptions">
                      <swiper-slide>
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/20220613_HAREM_03-1.png" alt="20220613_HAREM_03-1"></figure>
                      </swiper-slide>


                      <swiper-slide>
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/20220613_HAREM_04-1.png" alt="20220613_HAREM_04-1"></figure>
                      </swiper-slide>
                      <swiper-slide>
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/20220613_HAREM_01-1-1.png" alt="20220613_HAREM_01-1 (1)">
                        </figure>
                      </swiper-slide>

                      <swiper-slide>
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/20220613_HAREM_02-1.png" alt="20220613_HAREM_02-1"></figure>
                      </swiper-slide>


                      <swiper-slide>
                        <figure class="swiper-slide-inner"><img decoding="async" class="swiper-slide-image"
                            src="/static/img/landing/20220613_HAREM_05-1.png" alt="20220613_HAREM_05-1"></figure>
                      </swiper-slide>

                    </swiper>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-7218285 elementor-section-full_width linecutbt02 elementor-section-height-default elementor-section-height-default"
          data-id="7218285" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-no">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f8f869e"
              data-id="f8f869e" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated e-swiper-container">
                <div class="elementor-element elementor-element-9690fd9 elementor-widget elementor-widget-button"
                  data-id="9690fd9" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">



                    <div class="elementor-button-wrapper">
                      <a href="https://kkk-789.com/#" class="elementor-button-link elementor-button elementor-size-sm"
                        role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-icon elementor-align-icon-left">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                              id="Layer_1" x="0px" y="0px" viewBox="0 0 496 496"
                              style="enable-background:new 0 0 496 496;" xml:space="preserve">
                              <polygon style="fill:#FFC114;" points="35.2,283.2 235.2,360 248,496 112,483.2 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 112,483.2 35.2,283.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="120,368 166.4,488 248,496 240,414.4 "></polygon>
                              <polyline style="fill:#FF9A15;" points="248,496 240,414.4 120,368 "></polyline>
                              <polygon style="fill:#FFC114;" points="460.8,283.2 384,483.2 248,496 260.8,360 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 260.8,360 460.8,283.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="376,368 256,414.4 248,496 329.6,488 "></polygon>
                              <polyline style="fill:#FF9A15;" points="248,496 329.6,488 376,368 "></polyline>
                              <polygon style="fill:#EAAD13;" points="248,0 391.2,322.4 248,496 104.8,322.4 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 104.8,322.4 248,0 "></polyline>
                              <polygon style="fill:#F9A035;" points="248,197.6 162.4,392 248,496 333.6,392 "></polygon>
                              <polyline style="fill:#EF8A11;" points="248,496 333.6,392 248,197.6 "></polyline>
                              <polygon style="fill:#FFC114;" points="48,75.2 128,176.8 92.8,250.4 26.4,202.4 "></polygon>
                              <polyline style="fill:#FFCD50;" points="92.8,250.4 26.4,202.4 48,75.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="65.6,145.6 52.8,221.6 92.8,250.4 113.6,206.4 ">
                              </polygon>
                              <polyline style="fill:#FF9A15;" points="92.8,250.4 113.6,206.4 65.6,145.6 "></polyline>
                              <polygon style="fill:#FFC114;" points="448,75.2 368,176.8 403.2,250.4 469.6,202.4 ">
                              </polygon>
                              <polyline style="fill:#FFCD50;" points="403.2,250.4 469.6,202.4 448,75.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="430.4,145.6 443.2,221.6 403.2,250.4 382.4,206.4 ">
                              </polygon>
                              <polyline style="fill:#FF9A15;" points="403.2,250.4 382.4,206.4 430.4,145.6 "></polyline>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                            </svg> </span>
                          <span class="elementor-button-text">10 อันดับค่ายเกมยอดนิยม</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-3fef537 dotbottom ranknumber elementor-widget elementor-widget-image-carousel e-widget-swiper"
                  data-id="3fef537" data-element_type="widget"
                  data-settings="{&quot;navigation&quot;:&quot;none&quot;,&quot;slides_to_show&quot;:&quot;5&quot;,&quot;slides_to_show_tablet&quot;:&quot;4&quot;,&quot;slides_to_show_mobile&quot;:&quot;2&quot;,&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;yes&quot;,&quot;speed&quot;:500,&quot;image_spacing_custom&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:20,&quot;sizes&quot;:[]}}"
                  data-widget_type="image-carousel.default">
                  <div class="elementor-widget-container">

                    <swiper v-bind="swiperOptionsHot">
                      <swiper-slide v-for="(item, i) in getGameList.ImageSlot" :key="i" v-show="i < 10">
                        <figure
                          style="background: #ffffff29;
                                                                                                                                                                                                                                                    border-radius: 20px;"
                          class="swiper-slide-inner">
                          <img
                            style="height: 150px;
                                                                                                                                                                                                                                                    object-fit: contain;"
                            decoding="async" class="swiper-slide-image" :src="item.img.replace('game', 'game_tranparent')"
                            alt="6">
                          <figcaption class="elementor-image-carousel-caption">{{ i + 1 }}</figcaption>
                        </figure>
                      </swiper-slide>
                    </swiper>


                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-386e882 elementor-widget elementor-widget-global elementor-global-2680 elementor-widget-button"
                  data-id="386e882" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper">
                      <a href="#" class="elementor-button-link elementor-button elementor-size-sm" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-icon elementor-align-icon-left">
                            <svg width="64px" height="64px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img"
                              class="iconify iconify--emojione" preserveAspectRatio="xMidYMid meet">
                              <path
                                d="M60.6 41.9c1.2-2.5 1.7-4.7 1.2-5c-.3-.1-1 .5-1.7 1.6l-8.1-14L30 5.1l-5.1-.8c1.5-.9 2.4-1.7 2.2-2.1c-.2-.5-2.5 0-5 1.2s-4.3 2.5-4.1 3c.1.2.7.2 1.5.1C18.1 9 10.6 22 10.6 22L8.8 47.5l1.1 1.1c-.6-.3-1-.5-1.2-.3c-.4.4.9 2.3 2.8 4.3c2 2 3.9 3.2 4.3 2.8c.2-.2 0-.8-.6-1.6L31 56.4l23.1-8.5l3.6-4.1c-.4 1.2-.4 2.1-.1 2.3c.5.1 1.8-1.7 3-4.2"
                                fill="#d0d0d0"></path>
                              <g fill="#e8e8e8">
                                <path
                                  d="M44.1 59.8c-1.9 1.9-5.5 2.7-8.2 1.9l-19.7-6c-2.7-.8-3.3-3-1.5-4.8l13.7-13.7c1.9-1.9 5.5-2.7 8.2-1.9l19.7 6c2.7.8 3.3 3 1.5 4.8L44.1 59.8">
                                </path>
                                <path
                                  d="M4.2 19.9c-1.9 1.9-2.7 5.5-1.9 8.2l6 19.7c.8 2.7 3 3.3 4.8 1.5l13.7-13.7c1.9-1.9 2.7-5.5 1.9-8.2l-6-19.7c-.8-2.7-3-3.3-4.8-1.5L4.2 19.9">
                                </path>
                              </g>
                              <path
                                d="M55 15.7C54 13 51 10 48.3 9L27.8 2.3c-2.8-.9-4.3.6-3.4 3.4l6.8 20.4c.9 2.8 3.9 5.8 6.7 6.7l20.4 6.8c2.8.9 4.3-.6 3.4-3.4L55 15.7"
                                fill="#f5f5f5"></path>
                              <path
                                d="M41.1 18.1c-.7 0-1.2.3-1.4.8c-.3 1.1.9 2.8 2.8 3.9c.9.5 1.8.8 2.5.8s1.2-.3 1.4-.8c.3-1.1-.9-2.8-2.8-3.9c-.8-.5-1.8-.8-2.5-.8"
                                fill="#ed4c5c"></path>
                              <g fill="#333">
                                <path
                                  d="M29 48.7c.7.2 1.1.7 1 1.2c-.1 1.1-1.8 2.4-3.9 2.8c-1.1.2-2 .2-2.7-.1c-.7-.2-1.1-.7-1-1.2c.1-1.1 1.8-2.4 3.9-2.8c1.1-.2 2.1-.2 2.7.1">
                                </path>
                                <path
                                  d="M39.2 46.4c.7.2 1.1.7 1 1.2c-.1 1.1-1.8 2.4-3.9 2.8c-1.1.2-2 .2-2.7-.1c-.7-.2-1.1-.7-1-1.2c.1-1.1 1.8-2.4 3.9-2.8c1.1-.2 2.1-.2 2.7.1">
                                </path>
                                <path
                                  d="M49 44.4c.7.2 1.1.7 1 1.2c-.1 1.1-1.8 2.4-3.9 2.8c-1.1.2-2 .2-2.7-.1c-.7-.2-1.1-.7-1-1.2c.1-1.1 1.8-2.4 3.9-2.8c1.1-.2 2-.1 2.7.1">
                                </path>
                              </g>
                              <g fill="#333">
                                <path
                                  d="M21 26.1c.6-.4 1.1-.5 1.6-.2c.9.7 1 2.8.2 4.8c-.4 1-.9 1.8-1.5 2.2c-.6.4-1.1.5-1.6.2c-.9-.7-1-2.8-.2-4.8c.4-1 1-1.8 1.5-2.2">
                                </path>
                                <path
                                  d="M9.7 22.6c.6-.4 1.1-.5 1.6-.2c.9.7 1 2.8.2 4.8c-.4 1-.9 1.8-1.5 2.2c-.6.4-1.1.5-1.6.2c-.9-.7-1-2.8-.2-4.8c.4-1 .9-1.7 1.5-2.2">
                                </path>
                              </g>
                            </svg> </span>
                          <span class="elementor-button-text">ค่ายสล็อต</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-6c29dab elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                  data-id="6c29dab" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-2eb1f42"
                      data-id="2eb1f42" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-9f470bb elementor-widget elementor-widget-shortcode"
                          data-id="9f470bb" data-element_type="widget" data-widget_type="shortcode.default">
                          <div class="elementor-widget-container">
                            <nav class="nav-menu" id="navbarProvider">
                              <ul class="nav nav-pills" id="htmlGameLists2">

                                <li v-for="(item, i) in getGameList.ImageSlot" :key="i"
                                  class="nav-item -game-casino-macro-container gamelist">
                                  <div class="x-game-list-item-macro js-game-list-toggle -big ">
                                    <div class="-inner-wrapper">

                                      <a href="#">
                                        <img :src="item.img" class="-cover-img img-fluid" alt="KA Gaming"
                                          style="cursor: pointer;">
                                      </a>
                                      <div class="-overlay">
                                        <div class="-overlay-inner">
                                          <div class="-wrapper-container">
                                            <a class="-btn -btn-play js-account-approve-aware" href="#">
                                              <i class="fas fa-play"></i>
                                              <span class="-text-btn">เข้าเล่น</span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="-title">{{ item.ch }}</div>
                                  </div>
                                </li>


                              </ul>
                            </nav>

                            <div class="elementor-shortcode"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div class="elementor-element elementor-element-e340a36 elementor-widget elementor-widget-button"
                  data-id="e340a36" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper">
                      <a href="#" class="elementor-button-link elementor-button elementor-size-sm" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-icon elementor-align-icon-left">
                            <!--?xml version="1.0" encoding="iso-8859-1"?-->
                            <!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->

                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60.036 60.036"
                              style="enable-background:new 0 0 60.036 60.036;" xml:space="preserve">
                              <g>
                                <path
                                  d="M57.41,8.509L28.906,2.361c-1.762-0.379-3.575,0.8-3.953,2.551l-9,41.725c-0.188,0.868-0.025,1.758,0.456,2.505
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c0.482,0.747,1.226,1.261,2.094,1.448l28.504,6.148c0.231,0.05,0.468,0.075,0.703,0.075c1.555,0,2.922-1.104,3.25-2.626l9-41.725
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  C60.347,10.67,59.203,8.897,57.41,8.509z M49.018,32.655c-1.864,2.346-5.642,5.783-13.058,8.837l-0.637,0.262l-0.472-0.501
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c-5.499-5.841-7.523-10.529-8.253-13.434c-0.539-2.144-0.087-4.642,1.207-6.682c1.212-1.91,2.963-3.175,4.931-3.562
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c0.469-0.092,0.938-0.139,1.396-0.139c2.968,0,4.885,1.895,5.78,3.052c0.837-0.442,2.191-0.989,3.775-0.989
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c1.424,0,2.757,0.436,3.961,1.293c1.634,1.163,2.708,3.038,3.025,5.278C51.011,28.463,50.393,30.924,49.018,32.655z">
                                </path>
                                <path
                                  d="M14.728,50.225c-0.771-1.196-1.031-2.621-0.73-4.011l1.701-7.888c-0.176,0.014-0.35,0.033-0.533,0.033c0,0,0,0,0,0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c-1.237,0-2.428-0.341-3.54-1.014c-1.716-1.038-2.928-2.827-3.411-5.037c-0.516-2.36-0.083-4.86,1.157-6.688
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c1.575-2.32,4.752-5.72,11.031-9.099l2.133-9.891L9.635,4.845C7.798,4.591,6.131,5.897,5.883,7.684L0.032,49.965
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  c-0.251,1.816,1.022,3.499,2.839,3.751l28.885,3.997c0.154,0.021,0.307,0.032,0.458,0.032c1.161,0,2.196-0.618,2.793-1.551
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  l-16.925-3.651C16.69,52.244,15.499,51.42,14.728,50.225z">
                                </path>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                              <g>
                              </g>
                            </svg>
                          </span>
                          <span class="elementor-button-text">ค่ายคาสิโน</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-b5b4b8f elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                  data-id="b5b4b8f" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-a0deade"
                      data-id="a0deade" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-1ac9a7e elementor-widget elementor-widget-shortcode"
                          data-id="1ac9a7e" data-element_type="widget" data-widget_type="shortcode.default">
                          <div class="elementor-widget-container">
                            <nav class="nav-menu" id="navbarProvider">
                              <ul class="nav nav-pills" id="htmlGameLists">

                                <li v-for="(item, i) in getGameList.ImageCasino" :key="i"
                                  class="nav-item -game-casino-macro-container gamelist">
                                  <div class="x-game-list-item-macro js-game-list-toggle -big ">
                                    <div class="-inner-wrapper">

                                      <a href="#">
                                        <img :src="item.img" class="-cover-img img-fluid" alt="WMCasino"
                                          style="cursor: pointer;">
                                      </a>
                                      <div class="-overlay">
                                        <div class="-overlay-inner">
                                          <div class="-wrapper-container">
                                            <a class="-btn -btn-play js-account-approve-aware" href="#">
                                              <i class="fas fa-play"></i>
                                              <span class="-text-btn">เข้าเล่น</span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="-title">{{ item.ch }}</div>
                                  </div>
                                </li>


                              </ul>
                            </nav>

                            <div class="elementor-shortcode"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-5a97a30 linecutbt02 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="5a97a30" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bd38ea4"
              data-id="bd38ea4" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-83acfb2 elementor-widget elementor-widget-heading"
                  data-id="83acfb2" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">ฝาก-ถอน ออโต้
                      โปรแรงสุดในไทย อัพเกรดใหม่ {{ appTitle }} ระบบไวกว่าเดิม</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-f84249b elementor-widget elementor-widget-theme-site-logo elementor-widget-image"
                  data-id="f84249b" data-element_type="widget" data-widget_type="theme-site-logo.default">
                  <div class="elementor-widget-container">
                    <a href="#">
                      <img decoding="async" width="960" height="960" src="/static/img/landing/cropped-GMZ555.png"
                        class="attachment-full size-full" alt="" loading="lazy"
                        srcset="/static/img/landing/cropped-GMZ555.png 960w, /static/img/landing/cropped-VENOM168-300x300.png 300w, /static/img/landing/cropped-VENOM168-150x150.png 150w, /static/img/landing/cropped-VENOM168-768x768.png 768w, /static/img/landing/cropped-VENOM168-50x50.png 50w"
                        sizes="(max-width: 960px) 100vw, 960px"> </a>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-f0323cb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f0323cb" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-a1e1926"
                      data-id="a1e1926" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-1609734 elementor-widget elementor-widget-heading"
                          data-id="1609734" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h3 class="elementor-heading-title elementor-size-default">
                              ยินดีต้อนรับเข้าสู่ {{ appTitle }}</h3>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-c2b13ce linegoldleft elementor-widget elementor-widget-text-editor"
                          data-id="c2b13ce" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container">
                            <p><strong>เว็บพนันออนไลน์ที่ยิ่งใหญ่ที่สุดในยุคนี้</strong></p>
                            <p>ศูนย์รวมคาสิโนและค่ายสล็อตทุกค่าย สมัครเข้ามาเป็นนักบิด
                              ในสนามของเรา เพื่อรับสิทธิพิเศษทุกสัปดาห์
                              ครอบคลุมธุรกรรมการเงินด้วยเทคโนโลยีล้ำสมัย ฝาก-ถอน ไวตลอด 24
                              ชั่วโมง {{ appTitle }} เว็บชั้นนำ เร็ว แรง ทะลุไมล์</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8677bcb"
                      data-id="8677bcb" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-15dab0c elementor-widget elementor-widget-image"
                          data-id="15dab0c" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container">
                            <img decoding="async" width="800" height="450"
                              src="/static/img/landing/home-highlight-3dcf6afd-1.png" class="attachment-large size-large"
                              alt="" loading="lazy"
                              srcset="/static/img/landing/home-highlight-3dcf6afd-1.png 800w, /static/img/landing/home-highlight-3dcf6afd-1.png 300w, /static/img/landing/home-highlight-3dcf6afd-1.png 768w, /static/img/landing/home-highlight-3dcf6afd-1.png 50w"
                              sizes="(max-width: 800px) 100vw, 800px">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  class="elementor-element elementor-element-e7e67e2 elementor-align-center elementor-widget elementor-widget-button"
                  data-id="e7e67e2" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper">
                      <a href="/" class="elementor-button-link elementor-button elementor-size-sm" role="button">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-icon elementor-align-icon-left">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                              id="Layer_1" x="0px" y="0px" viewBox="0 0 496 496"
                              style="enable-background:new 0 0 496 496;" xml:space="preserve">
                              <polygon style="fill:#FFC114;" points="35.2,283.2 235.2,360 248,496 112,483.2 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 112,483.2 35.2,283.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="120,368 166.4,488 248,496 240,414.4 "></polygon>
                              <polyline style="fill:#FF9A15;" points="248,496 240,414.4 120,368 "></polyline>
                              <polygon style="fill:#FFC114;" points="460.8,283.2 384,483.2 248,496 260.8,360 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 260.8,360 460.8,283.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="376,368 256,414.4 248,496 329.6,488 "></polygon>
                              <polyline style="fill:#FF9A15;" points="248,496 329.6,488 376,368 "></polyline>
                              <polygon style="fill:#EAAD13;" points="248,0 391.2,322.4 248,496 104.8,322.4 "></polygon>
                              <polyline style="fill:#FFCD50;" points="248,496 104.8,322.4 248,0 "></polyline>
                              <polygon style="fill:#F9A035;" points="248,197.6 162.4,392 248,496 333.6,392 "></polygon>
                              <polyline style="fill:#EF8A11;" points="248,496 333.6,392 248,197.6 "></polyline>
                              <polygon style="fill:#FFC114;" points="48,75.2 128,176.8 92.8,250.4 26.4,202.4 "></polygon>
                              <polyline style="fill:#FFCD50;" points="92.8,250.4 26.4,202.4 48,75.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="65.6,145.6 52.8,221.6 92.8,250.4 113.6,206.4 ">
                              </polygon>
                              <polyline style="fill:#FF9A15;" points="92.8,250.4 113.6,206.4 65.6,145.6 "></polyline>
                              <polygon style="fill:#FFC114;" points="448,75.2 368,176.8 403.2,250.4 469.6,202.4 ">
                              </polygon>
                              <polyline style="fill:#FFCD50;" points="403.2,250.4 469.6,202.4 448,75.2 "></polyline>
                              <polygon style="fill:#F9A035;" points="430.4,145.6 443.2,221.6 403.2,250.4 382.4,206.4 ">
                              </polygon>
                              <polyline style="fill:#FF9A15;" points="403.2,250.4 382.4,206.4 430.4,145.6 "></polyline>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                              <g></g>
                            </svg> </span>
                          <span class="elementor-button-text">โปรโมชั่น</span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-46beb67 uael-ins-normal uael-img-carousel-arrow-outside elementor-widget elementor-widget-uael-image-gallery"
                  data-id="46beb67" data-element_type="widget"
                  data-settings="{&quot;slides_to_show&quot;:3,&quot;slides_to_show_tablet&quot;:2,&quot;slides_to_show_mobile&quot;:1,&quot;slides_to_scroll&quot;:1,&quot;slides_to_scroll_tablet&quot;:1,&quot;slides_to_scroll_mobile&quot;:1,&quot;column_gap&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:20,&quot;sizes&quot;:[]},&quot;column_gap_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;column_gap_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}"
                  data-widget_type="uael-image-gallery.default">
                  <div class="elementor-widget-container">


                    <carousel-3d :height="360" :autoplay="true" :autoplay-timeout="3000" :controls-visible="true">
                      <slide :index="0">
                        <figure class="uael-grid-img uael-grid-gallery-img uael-ins-hover elementor-clickable">
                          <div class="uael-grid-img-thumbnail uael-ins-target">
                            <img decoding="async" width="800" height="800" src="/static/img/landing/02-1.jpg"
                              class="attachment-large size-large" alt="" loading="lazy">
                          </div>
                          <div class="uael-grid-img-overlay"></div>
                        </figure>
                      </slide>
                      <slide :index="1" style="height: 360px;">
                        <figure class="uael-grid-img uael-grid-gallery-img uael-ins-hover elementor-clickable">
                          <div class="uael-grid-img-thumbnail uael-ins-target">
                            <img decoding="async" width="800" height="800" src="/static/img/landing/02-1-2.jpg"
                              class="attachment-large size-large" alt="" loading="lazy">
                          </div>
                          <div class="uael-grid-img-overlay"></div>
                        </figure>
                      </slide>
                      <slide :index="2" style="height: 360px;">
                        <figure class="uael-grid-img uael-grid-gallery-img uael-ins-hover elementor-clickable">
                          <div class="uael-grid-img-thumbnail uael-ins-target">
                            <img decoding="async" width="800" height="800" src="/static/img/landing/02-1-3.jpg"
                              class="attachment-large size-large" alt="" loading="lazy">
                          </div>
                          <div class="uael-grid-img-overlay"></div>
                        </figure>
                      </slide>
                      <slide :index="3" style="height: 360px;">
                        <figure class="uael-grid-img uael-grid-gallery-img uael-ins-hover elementor-clickable">
                          <div class="uael-grid-img-thumbnail uael-ins-target">
                            <img decoding="async" width="800" height="800" src="/static/img/landing/02-1-4.jpg"
                              class="attachment-large size-large" alt="" loading="lazy">
                          </div>
                          <div class="uael-grid-img-overlay"></div>
                        </figure>
                      </slide>
                      <slide :index="4" style="height: 360px;">
                        <figure class="uael-grid-img uael-grid-gallery-img uael-ins-hover elementor-clickable">
                          <div class="uael-grid-img-thumbnail uael-ins-target">
                            <img decoding="async" width="800" height="800" src="/static/img/landing/02-1-5.jpg"
                              class="attachment-large size-large" alt="" loading="lazy">
                          </div>
                          <div class="uael-grid-img-overlay"></div>
                        </figure>
                      </slide>
                    </carousel-3d>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-5f4bac0 linecutbt02 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="5f4bac0" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f4d384e"
              data-id="f4d384e" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-f9837da elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f9837da" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-72cc41d"
                      data-id="72cc41d" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-7a3a354 elementor-widget elementor-widget-heading"
                          data-id="7a3a354" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h2 class="elementor-heading-title elementor-size-default">
                              เกี่ยวกับเรา {{ appTitle }}</h2>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-db059ea elementor-widget elementor-widget-text-editor"
                          data-id="db059ea" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container">
                            <p>เมื่อยุคสมัยเปลี่ยนไป โลกของการสร้างรายได้ บนโลกออนไลน์
                              ที่เป็นแค่โลกเสมือนจริง ได้เปลี่ยนความไม่แน่นอน
                              ให้เกิดความแน่นอน ทั้งยังสร้างรายได้ที่มั่นคง และง่ายดาย
                              ได้มากกว่า ไม่ว่าคุณจะเป็นใคร
                              ก็หาเงินได้ง่ายยิ่งกว่าปลอกกล้วยเข้าปาก ได้จริง ๆ
                              ด้วยสิ่งสำคัญเพียงข้อเดียวคือ…การเลือก คาสิโนออนไลน์
                              ที่เชื่อถือได้ และให้บริการแก่สมาชิกทุก ๆ ท่านได้
                              อย่างไม่มีแบ่งแยก ไม่เลือกปฎิบัติ ไม่สร้างความเครียด
                              เหมือนดั่งการทำเงิน ในรูปแบบอื่น ๆ บนโลกของความเป็นจริง
                              และถ้าหากคุณเป็นหนึ่งคน ที่กำลังมองหาการสร้างรายได้ ในรูปแบบนี้
                              การเข้ามาที่ คาสิโนออนไลน์ {{ appTitle }} แห่งนี้ แปลว่าคุณมาถูกที่
                              ถูกทางแล้ว เพราะในปี 2021 นี้ ไม่มีแหล่งรายได้ใด
                              ที่จะมอบประสบการณ์ทางเลือกใหม่ ได้เต็มรูปแบบ ครบวงจร
                              และสร้างความหลากหลาย ได้เงินจริง!! ได้เท่ากับ ที่ คาสิโนออนไลน์
                              {{ appTitle }} อีกแล้วอย่างแน่นอน</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-af49810"
                      data-id="af49810" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-7baa090 elementor-widget elementor-widget-image"
                          data-id="7baa090" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container">
                            <img decoding="async" width="484" height="489" src="/static/img/landing/292-1.png"
                              class="attachment-large size-large" alt="" loading="lazy"
                              srcset="/static/img/landing/292-1.png 484w, /static/img/landing/292-1.png 297w, /static/img/landing/292-1.png 50w"
                              sizes="(max-width: 484px) 100vw, 484px">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-0418260 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="0418260" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b24a029"
              data-id="b24a029" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated e-swiper-container">
                <div
                  class="elementor-element elementor-element-19914e0 elementor-widget elementor-widget-image-carousel e-widget-swiper"
                  data-id="19914e0" data-element_type="widget"
                  data-settings="{&quot;slides_to_show&quot;:&quot;9&quot;,&quot;slides_to_show_tablet&quot;:&quot;5&quot;,&quot;slides_to_show_mobile&quot;:&quot;3&quot;,&quot;navigation&quot;:&quot;none&quot;,&quot;autoplay&quot;:&quot;yes&quot;,&quot;pause_on_hover&quot;:&quot;yes&quot;,&quot;pause_on_interaction&quot;:&quot;yes&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;yes&quot;,&quot;speed&quot;:500,&quot;image_spacing_custom&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:20,&quot;sizes&quot;:[]}}"
                  data-widget_type="image-carousel.default">
                  <div class="elementor-widget-container">

                    <swiper v-bind="swiperOptionsFooter">
                      <swiper-slide v-for="(item, i) in getGameList.ImageSlot" :key="i">

                        <img
                          style="height: 80px; width: 106.667px;
                                                                                                                                                                                                                                                  object-fit: contain;"
                          decoding="async" class="swiper-slide-image" :src="item.img.replace('game', 'game_tranparent')"
                          alt="6">

                      </swiper-slide>
                    </swiper>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-f63eb11 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="f63eb11" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e525459"
              data-id="e525459" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-e70d634 elementor-widget elementor-widget-heading"
                  data-id="e70d634" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h4 class="elementor-heading-title elementor-size-default">สมัครสมาชิก {{ appTitle }}
                      พร้อมรับโบนัสอีกมากมาย</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


    </div>
    <footer class="mt-auto">
      <div class="-inner-wrapper">

        <div class="container -image-wrapper d-flex justify-content-center align-items-center px-3 px-lg-0 flex-wrap">
          <div class="fotterctn">
            <div class="disfooterct">
              <div class="infootergrid p-0 text-break">
                <div class="text-center">
                </div>
                <div class="bankcontainer">
                  <div class="bank-footer">
                    <h2 class="widgettitle">ช่องทางการฝากเงิน</h2>

                    <div id="gallery-1" class="gallery galleryid-216 gallery-columns-9 gallery-size-thumbnail">
                      <dl class="gallery-item">
                        <dt class="gallery-icon portrait">
                          <a href="#"><img width="150" height="150" src="/static/img/landing/5-1-150x150.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              sizes="(max-width: 150px) 100vw, 150px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="120" height="120" src="/static/img/landing/4-1.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              sizes="(max-width: 120px) 100vw, 120px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="121" height="120" src="/static/img/landing/3-1.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/3-1.png 121w, /static/img/landing/3-1-24x24.png 24w, /static/img/landing/3-1-36x36.png 36w, /static/img/landing/3-1-48x48.png 48w"
                              sizes="(max-width: 121px) 100vw, 121px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="120" height="120" src="/static/img/landing/2-1.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/2-1.png 120w, /static/img/landing/2-1-24x24.png 24w, /static/img/landing/2-1-36x36.png 36w, /static/img/landing/2-1-48x48.png 48w"
                              sizes="(max-width: 120px) 100vw, 120px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="121" height="120" src="/static/img/landing/1-1.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/1-1.png 121w, /static/img/landing/1-1-24x24.png 24w, /static/img/landing/1-1-36x36.png 36w, /static/img/landing/1-1-48x48.png 48w"
                              sizes="(max-width: 121px) 100vw, 121px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon portrait">
                          <a href="#"><img width="119" height="120" src="/static/img/landing/7.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/7.png 119w, /static/img/landing/7-24x24.png 24w, /static/img/landing/7-36x36.png 36w, /static/img/landing/7-48x48.png 48w"
                              sizes="(max-width: 119px) 100vw, 119px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="120" height="120" src="/static/img/landing/6-1.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/6-1.png 120w, /static/img/landing/6-1-24x24.png 24w, /static/img/landing/6-1-36x36.png 36w, /static/img/landing/6-1-48x48.png 48w"
                              sizes="(max-width: 120px) 100vw, 120px"></a>
                        </dt>
                      </dl>
                      <dl class="gallery-item">
                        <dt class="gallery-icon landscape">
                          <a href="#"><img width="150" height="150" src="/static/img/landing/true-150x150.png"
                              class="attachment-thumbnail size-thumbnail" alt="" decoding="async" loading="lazy"
                              srcset="/static/img/landing/true-150x150.png 150w, /static/img/landing/true-150x150.png 300w, /static/img/landing/true-150x150.png 50w, /static/img/landing/true-150x150.png 472w"
                              sizes="(max-width: 150px) 100vw, 150px"></a>
                        </dt>
                      </dl>
                      <br style="clear: both">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="footercontain">
            <div class="disfooterct">
              <div class="infootergrid pt-3">
                <div class="-tags-wrapper">
                  <div class="container">
                    <div class="row x-footer-seo">
                      <div class="col-12 mb-3 d-block d-lg-none">
                      </div>
                      <div class="col-12 -tags">
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">ทดสอบ</a></div>
                        </div>
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">{{ appTitle }}</a></div>
                        </div>
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">คาสิโนสด</a></div>
                        </div>
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">เกมยิงปลา</a>
                          </div>
                        </div>
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">สล็อต</a></div>
                        </div>
                        <div class="btn btn-sm">
                          <div class="textwidget"><a href="#">เว็บพนัน</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="infootergrid pt-3">
                <div class="mx-auto"><img width="512" height="512" src="/static/img/landing/cropped-GMZ555-1.png"
                    class="image wp-image-2652  attachment-full size-full" alt="" decoding="async" loading="lazy"
                    style="max-width: 100%; height: auto;"
                    srcset="/static/img/landing/cropped-GMZ555-1.png 512w, /static/img/landing/cropped-GMZ555-1-300x300.png 300w, /static/img/landing/cropped-GMZ555-1-150x150.png 150w, /static/img/landing/cropped-GMZ555-1-50x50.png 50w, /static/img/landing/cropped-GMZ555-1-270x270.png 270w, /static/img/landing/cropped-GMZ555-1-192x192.png 192w, /static/img/landing/cropped-GMZ555-1-180x180.png 180w, /static/img/landing/cropped-GMZ555-1-32x32.png 32w"
                    sizes="(max-width: 512px) 100vw, 512px"></div>
                <div class="mx-auto">
                  <div class="textwidget">2022 © {{ appTitle }} . All Rights Reserved. | Version: (2.6.33)</div>
                </div>
              </div>
              <div class="infootergrid pt-3"></div>
            </div>
          </div>
        </div>
      </div>
    </footer>



    <div class="loadercontain" style="display: none;">
      <a href="#" class="custom-logo-link" rel="home" aria-current="page"><img width="960" height="960"
          src="/static/img/landing/cropped-GMZ555.png" class="custom-logo" alt="VENOM168" decoding="async"
          sizes="(max-width: 960px) 100vw, 960px"></a>
      <div id="loadmeta">
        <span>
        </span>
      </div>
    </div>



    <div class="x-button-actions" id="account-actions-mobile">
      <div class="-outer-wrapper">
        <div class="-left-wrapper">

          <span class="-item-wrapper">
            <span class="-ic-img">
              <span class="-textfooter d-block">
                <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">เข้าสู่ระบบ</a>
                <a href="javascript:;" class="wpGlobalB" style="">ฝากเงิน</a>
              </span>
              <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                style="display: none;">
                <img width="150" height="150" src="/static/img/landing/ic-menu-login-animate.png"
                  class="image wp-image-1199  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
              <a href="javascript:;" class="wpGlobalB" style="">
                <img width="150" height="150" src="/static/img/landing/deposit.png"
                  class="image wp-image-1199  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
            </span>
          </span>
          <span class="-item-wrapper">
            <span class="-ic-img">
              <span class="-textfooter d-block">
                <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">สมัคร</a>
                <a href="javascript:;" class="wpGlobalB" datatoggle="modal" data-target="#modalLogin" style="">ถอนเงิน</a>
              </span>
              <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#otp-modal"
                style="display: none;">
                <img width="50" height="50" src="/static/img/landing/id-w-1.png"
                  class="image wp-image-1200  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
              <a href="javascript:;" class="wpGlobalB" style="">
                <img width="50" height="50" src="/static/img/landing/id-w-1.png"
                  class="image wp-image-1200  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
            </span>
          </span>
        </div>
        <span class="-center-wrapper js-footer-lobby-selector js-menu-mobile-container">
          <div class="-selected">
            <img width="300" height="275" src="/static/img/landing/Artboard-6-300x275-1.png"
              class="image wp-image-1186  attachment-medium size-medium" alt="" decoding="async" loading="lazy">
          </div>
        </span>

        <div class="-fake-center-bg-wrapper">
          <svg viewBox="-10 -1 30 12">
            <defs>
              <lineargradient id="rectangleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stop-color="#490a50"></stop>
                <stop offset="100%" stop-color="#180032"></stop>
              </lineargradient>
            </defs>
            <path d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"></path>
          </svg>
        </div>
        <div class="-right-wrapper">
          <span class="-item-wrapper">
            <div class="boxsmain-footer" style="display: none;" attrs="1">
              <div class="boxs">
                <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">
                  <img width="100" height="100" src="/static/img/landing/id-d-1_.png"
                    class="image wp-image-877  attachment-full size-full" alt="" decoding="async" loading="lazy"
                    style="max-width: 100%; height: auto;">
                </a>
                <a href="javascript:;" class="wpGlobalB" style="">
                  <img width="100" height="100" src="/static/img/landing/id-d-1_.png"
                    class="image wp-image-877  attachment-full size-full" alt="" decoding="async" loading="lazy"
                    style="max-width: 100%; height: auto;">
                </a>
                <a href="javascript:;" class="wpGlobalA -text3" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">ฝากเงิน</a>
                <a href="javascript:;" class="wpGlobalB -text3" style="">ฝากเงิน</a>
              </div>
              <div class="boxs" style="margin-right: 0px !important;">
                <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">
                  <img width="100" height="100" src="/static/img/landing/tab_manual.png"
                    class="image wp-image-877  attachment-full size-full" alt="" decoding="async" loading="lazy"
                    style="max-width: 100%; height: auto;">
                </a>
                <a href="javascript:;" class="wpGlobalB" style="">
                  <img width="100" height="100" src="/static/img/landing/tab_manual.png"
                    class="image wp-image-877  attachment-full size-full" alt="" decoding="async" loading="lazy"
                    style="max-width: 100%; height: auto;">
                </a>
                <a href="javascript:;" class="wpGlobalA -text3" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">ถอนเงิน</a>
                <a href="javascript:;" class="wpGlobalB -text3" style="">ถอนเงิน</a>
              </div>
            </div>
            <span class="-ic-img">
              <span class="-textfooter d-block">
                <a href="javascript:;">แนะนำเพื่อน</a>
              </span>
              <a href="javascript:;">
                <img width="100" height="100" src="/static/img/landing/tab_manual.png"
                  class="image wp-image-877  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
            </span>
          </span>
          <span class="-item-wrapper">
            <span class="-ic-img">
              <span class="-textfooter d-block">
                <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#modalLogin"
                  style="display: none;">แนะนำเพื่อน</a>
                <a href="javascript:;" class="wpGlobalB" style="">สมาชิก</a>
              </span>
              <a href="javascript:;" class="wpGlobalA" data-toggle="modal" data-target="#loginModal"
                style="display: none;">
                <img width="150" height="150" src="/static/img/landing/ic-menu-register(1).png"
                  class="image wp-image-876  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
              <a href="javascript:;" class="wpGlobalB" style="">
                <img width="150" height="150" src="/static/img/landing/ic-menu-register(1).png"
                  class="image wp-image-876  attachment-full size-full" alt="" decoding="async" loading="lazy"
                  style="max-width: 100%; height: auto;">
              </a>
            </span>
          </span>
        </div>
        <div class="-fully-overlay js-footer-lobby-overlay"></div>
      </div>
    </div>

    <div class="linefixed"><a v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank"><img width="150"
          height="231" src="/static/img/landing/contact-us.png" class="image wp-image-1089  attachment-full size-full"
          alt="" decoding="async" loading="lazy" style="max-width: 100%; height: auto;"
          sizes="(max-width: 150px) 100vw, 150px"></a></div>


    <LoginForm></LoginForm>
    <RegisterForm></RegisterForm>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getPrefix } from '@/services/modules/global.js'
import { reward } from '@/config/reward.js'


import Header from '@/components/layout/Header'
import { Navigation, Pagination, Autoplay } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
// import 'swiper/swiper-bundle.css'
SwiperCore.use([Navigation, Pagination, Autoplay])

import LoginForm from '@/components/form/LoginForm'
import RegisterForm from '@/components/form/RegisterForm'
// import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from "vue-owl-carousel";
export default {
  name: 'Index',
  data() {
    return {
      phoneNumber: '',
      password: '',
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        loop: true,
        slidesPerView: "2",
        spaceBetween: 0,
        navigation: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        breakpoints: {
          320: {
            slidesPerView: 1,
          },
          1023: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          }
        },

      },
      swiperOptionsHot: {
        slidesPerView: "2",
        spaceBetween: 20,
        // navigation: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          1023: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 6,
          }
        },



      },

      swiperOptionsFooter: {
        slidesPerView: "2",
        spaceBetween: 20,
        // navigation: true,
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        breakpoints: {
          320: {
            slidesPerView: 5,
          },
          1023: {
            slidesPerView: 6,
          },
          1024: {
            slidesPerView: 9,
          }
        },



      },

    };

  },
  components: {
    Header,
    RegisterForm,
    LoginForm,
    Swiper,
    SwiperSlide
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'appTitle',
    ]),
  },
  methods: {
    ...mapActions(['userSignIn', 'setError']),
    gotoRoute(route) {
      this.$router.push(route)
    },
    async Login() {
      if (
        this.phoneNumber == '' ||
        this.password == '' ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          'เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง',
          '',
          'error'
        )
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      })
      if (this.getError) {
        return this.$swal.fire(this.getError, '', 'error')
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem('remember.username', this.phoneNumber)
          localStorage.setItem('remember.password', this.password)
        } else {
          localStorage.removeItem('remember.username')
          localStorage.removeItem('remember.password')
        }
        localStorage.removeItem('modal-alert')
      }
    },
  },
  mounted() {
    this.setError(null)
    if (localStorage.getItem('remember.username') != null) {
      this.phoneNumber = localStorage.getItem('remember.username')
      this.remember = true
    }
    if (localStorage.getItem('remember.password') != null) {
      this.password = localStorage.getItem('remember.password')
      this.remember = true
    }
  },
}

</script>
 
<style >
.swiper-button-next {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU3IiBoZWlnaHQ9IjQ0OSIgdmlld0JveD0iMCAwIDI1NyA0NDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNDYuNjc1IDIwMS40NzVDMjU5LjE3NSAyMTMuOTc1IDI1OS4xNzUgMjM0LjI3NSAyNDYuNjc1IDI0Ni43NzVMNTQuNjc1IDQzOC43NzVDNDIuMTc1IDQ1MS4yNzUgMjEuODc1IDQ1MS4yNzUgOS4zNzUgNDM4Ljc3NUMtMy4xMjUgNDI2LjI3NSAtMy4xMjUgNDA1Ljk3NSA5LjM3NSAzOTMuNDc1TDE3OC43NzUgMjI0LjA3NUw5LjQ3NSA1NC42NzVDLTMuMDI1IDQyLjE3NSAtMy4wMjUgMjEuODc1IDkuNDc1IDkuMzc1QzIxLjk3NSAtMy4xMjUgNDIuMjc1IC0zLjEyNSA1NC43NzUgOS4zNzVMMjQ2Ljc3NSAyMDEuMzc1TDI0Ni42NzUgMjAxLjQ3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=') !important;
  right: 10px;
  left: auto;
  width: 40px;
  height: 40px;
  background-size: contain;
}

.swiper-button-prev {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU3IiBoZWlnaHQ9IjQ0OSIgdmlld0JveD0iMCAwIDI1NyA0NDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjM3NSAyMDEuNDc1Qy0zLjEyNSAyMTMuOTc1IC0zLjEyNSAyMzQuMjc1IDkuMzc1IDI0Ni43NzVMMjAxLjM3NSA0MzguNzc1QzIxMy44NzUgNDUxLjI3NSAyMzQuMTc1IDQ1MS4yNzUgMjQ2LjY3NSA0MzguNzc1QzI1OS4xNzUgNDI2LjI3NSAyNTkuMTc1IDQwNS45NzUgMjQ2LjY3NSAzOTMuNDc1TDc3LjI3NSAyMjQuMDc1TDI0Ni41NzUgNTQuNjc1QzI1OS4wNzUgNDIuMTc1IDI1OS4wNzUgMjEuODc1IDI0Ni41NzUgOS4zNzVDMjM0LjA3NSAtMy4xMjUgMjEzLjc3NSAtMy4xMjUgMjAxLjI3NSA5LjM3NUw5LjI3NSAyMDEuMzc1TDkuMzc1IDIwMS40NzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K') !important;
  left: 10px;
  right: auto;
  width: 40px;
  height: 40px;
  background-size: contain;
}

#gallery-1 {
  margin: auto;
}

#gallery-1 .gallery-item {
  float: left;
  margin-top: 10px;
  text-align: center;
  width: 11%;
}

#gallery-1 img {
  border: 2px solid #cfcfcf;
}

#gallery-1 .gallery-caption {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/Index.vue